import createReactComponent from '../createReactComponent';
export default createReactComponent('pennant-2', 'IconPennant2', [
  ['path', { d: 'M16 21h-4', key: 'svg-0' }],
  ['path', { d: 'M14 21v-18', key: 'svg-1' }],
  ['path', { d: 'M14 4l-9 4l9 4', key: 'svg-2' }],
]);
